import {Injectable} from '@angular/core';
import {AuthHttp} from '../core/auth-http.service';
import {Observable} from 'rxjs/Observable';
import {Supplier} from './product.types';
import {Response} from '@angular/http';

@Injectable()
export class SupplierService {
    constructor(private http: AuthHttp) {
    }

    public getSupplier(id: number): Observable<Supplier> {
        return this.http.get('prd/supplier/admin/' + id)
            .map((response) => response.json());
    }

    public getSuppliers(): Observable<Supplier[]> {
        return this.http.get('prd/supplier/admin')
            .map((response) => response.json());
    }

    public saveSupplier(supplier: Supplier) {
        let response: Observable<Response>;
        if (null === supplier.id) {
            response = this.http.post('prd/supplier/admin', supplier)
        } else {
            response = this.http.put('prd/supplier/admin/' + supplier.id, supplier);
        }

        return response
            .map(res => res.json());

    }

    public getSupplierSkeleton(): Supplier {
        return {
            id: null,
            code: '',
            desc: '',
            active: true,
            own: false,
            person: {
                id: null,
                personType: 'company',
                name1: '',
                name2: '',
                name3: '',
                title: '',
                lastName: '',
                firstName: '',
                middleName: '',
                nameSuffix: '',
                address1: '',
                address2: '',
                country: '',
                state: '',
                zip: '',
                city: '',
                language: '',
                formalityScale: 'formal'
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/product/supplier.service.ts